import React, { useEffect } from 'react';
import moment from 'moment';
import { useSelector, useDispatch } from "react-redux";
import { Col, Row, Spin, Tooltip } from "antd";
import { Area, AreaChart, ResponsiveContainer } from 'recharts';

import Widget from "../../components/Widget/index";
import { fetchGeneralTotal, fetchGeneralTotalCumulative, fetchMerchantTotal, fetchMerchantTotalCumulative } from "../../redux/actions/Aggregate";
import { generateDateTimeRange } from '../../util/lib';
import { fetchMerchantAccounts } from '../../redux/actions/Data';

const UsdCard = ({ merchantId }) => {
  const dispatch = useDispatch();
  const { timezone } = useSelector(({ settings }) => settings);
  const { data: generalHourlyUsd, loading: loadingGeneralHourlyUsd } = useSelector(({ aggregate }) => aggregate.generalHourlyUsd);
  const { data: generalUsdTotal, loading: loadingGeneralUsdTotal } = useSelector(({ aggregate }) => aggregate.generalUsdTotal);
  const { data: merchantHourlyUsd, loading: loadingMerchantHourlyUsd } = useSelector(({ aggregate }) => aggregate.merchantHourlyUsd);
  const { data: merchantUsdTotal, loading: loadingMerchantUsdTotal } = useSelector(({ aggregate }) => aggregate.merchantUsdTotal);
  const { data: merchantAccounts, loading: loadingMerchants } = useSelector(({ data }) => data.merchantAccounts);


  const todaysDate = moment().format('YYYY-MM-DD');
  const todaysDateWithTimezone = generateDateTimeRange(todaysDate, timezone);
  const yesterday = moment().subtract(1, 'days').format('YYYY-MM-DD');
  const yesterdayWithTimezone = generateDateTimeRange(yesterday, timezone);

  useEffect(() => {

    if (merchantId) {
      dispatch(fetchMerchantTotal(
        merchantId,
        'CARD',
        'USD',
        'COMPLETED',
        'hour',
        "None",
        `start=${todaysDateWithTimezone.start}&end=${todaysDateWithTimezone.end}`));

      dispatch(fetchMerchantTotalCumulative(
        merchantId,
        'CARD',
        'USD',
        'COMPLETED',
        'hour',
        'today',
        `start=${todaysDateWithTimezone.start}&end=${todaysDateWithTimezone.end}`));

      dispatch(fetchMerchantTotalCumulative(
        merchantId,
        'CARD',
        'USD',
        'COMPLETED',
        'hour',
        'yesterday',
        `start=${yesterdayWithTimezone.start}&end=${yesterdayWithTimezone.end}`));
    }
    else {
      dispatch(fetchMerchantAccounts());
    }

  }, [dispatch, merchantId, timezone]);

  useEffect(() => {
    if (merchantAccounts && merchantAccounts.length > 0) {
      const merchantIds = `merchant_id={"$in": [${merchantAccounts.map((account) => `"${account._id}"`).join(',')}]}`;
      const queries = [
        merchantIds,
        `start=${moment(todaysDateWithTimezone.start).format('YYYY-MM-DD')}`,
        `end=${moment(todaysDateWithTimezone.end).format('YYYY-MM-DD')}`
      ];

      const params = queries.join('&');

      dispatch(fetchGeneralTotal(
        'CARD',
        'USD',
        'COMPLETED',
        'hour',
        "None",
        params
      ));

      dispatch(fetchGeneralTotalCumulative(
        'CARD',
        'USD',
        'COMPLETED',
        'hour',
        'today',
        params
      ));

      dispatch(fetchGeneralTotalCumulative(
        'CARD',
        'USD',
        'COMPLETED',
        'hour',
        'yesterday',
        params
      ));
    }
  }, [merchantAccounts]);

  const data = merchantId ? merchantHourlyUsd : generalHourlyUsd;

  const loading = merchantId
    ? loadingMerchantHourlyUsd && loadingMerchantUsdTotal
    : loadingGeneralHourlyUsd && loadingGeneralUsdTotal;

  const total = merchantId ? merchantUsdTotal : generalUsdTotal;
  const totalAmountToday = total?.total_amount_today;
  const totalAmountYesterday = total?.total_amount_yesterday;

  const totalAmountChange = totalAmountToday && totalAmountYesterday && totalAmountYesterday !== 0
    ? ((totalAmountToday - totalAmountYesterday) / totalAmountYesterday * 100).toFixed(0)
    : 0;


  return (
    (!loading)
    && (<Widget styleName={`gx-card-full`}>
      <div className="gx-d-flex gx-px-4 gx-pt-4 gx-pb-2">
        <p className="gx-text-uppercase gx-chart-title">USD Collections</p>
        <p className="gx-ml-auto gx-text-primary">
          {
            totalAmountChange
          }%
          <i className={`icon icon-menu-${totalAmountToday > totalAmountYesterday ? 'up' : "down"} gx-fs-sm`} /></p>
      </div>
      <Row>
        <Col lg={12} md={12} sm={24} xs={24}>
          <div className="gx-actchart gx-pb-5 gx-pl-4">
            <h2 className="gx-fs-xxxl gx-font-weight-medium gx-mb-1 gx-text-black">
              ${!loading ? totalAmountToday : (<Spin className="gx-text-center" />)}
            </h2>
            <p className="gx-mb-0">Today</p>
          </div>
        </Col>
        <Col lg={12} md={12} sm={24} xs={24}>
          <ResponsiveContainer width="100%" height={50}>
            <AreaChart data={data}
              margin={{ top: 0, right: 0, left: 0, bottom: 0 }}>
              <Tooltip />
              <defs>
                <linearGradient id="color1" x1="0" y1="0" x2="1" y2="0">
                  <stop offset="5%" stopColor="#23DFDC" stopOpacity={0.9} />
                  <stop offset="95%" stopColor="#63AEE4" stopOpacity={0.9} />
                </linearGradient>
              </defs>
              <Area dataKey="total_amount" strokeWidth={0} stackId="2" stroke='#867AE5' fill="url(#color1)" fillOpacity={1} />
            </AreaChart>
          </ResponsiveContainer>
        </Col>
      </Row>
    </Widget>)
  )
};

export default UsdCard;
